import React, { useState, createContext } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import ErrorPage from './ErrorPage';
import reportWebVitals from './reportWebVitals';

export const ErrorContext = createContext();

const RootApp = () => {
  const [errorMessage, setErrorMessage] = useState('');
  return (
    <BrowserRouter>
      <ErrorContext.Provider value={{ errorMessage, setErrorMessage }}>
        <Routes>
          <Route path="/" element={errorMessage ? <ErrorPage /> : <App />} />
        </Routes>
      </ErrorContext.Provider>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
